import { css } from '@emotion/react';

export const container = css`
  position: relative;
  display: flex;
  align-items: center;
  padding: 6px 12px;
  box-sizing: border-box;
  min-height: 32px;
  font-size: 13px;
  font-weight: 600;
  color: var(--primary);
  cursor: pointer;
  border-radius: 10px;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
  transition: background-color 0.15s ease, transform 0.05s ease,
    box-shadow 0.15s ease;

  &:hover {
    background-color: var(--primary10);
  }

  &:active {
    transform: translateY(1px);
    background-color: var(--primary10);
  }

  &:focus-visible {
    outline: 2px solid var(--primary);
    outline-offset: 2px;
  }
  -webkit-text-size-adjust: none; /* 크롬, 사파리, 오페라 신버전 */
  -ms-text-size-adjust: none; /* IE */
  -moz-text-size-adjust: none; /* 파이어폭스 */
  -o-text-size-adjust: none; /* 오페라 구버전 */

  .oksoon-icon {
    display: flex;
    align-items: center;
    margin-left: 4px;
  }

  path {
    stroke: var(--primary);
  }
`;
